<style lang="less" rel="stylesheet/less" scoped>
    .wrapper{
        background:#ECEFF1;
        padding:18px 0;
        box-sizing:border-box;
    }
    .button-group{
        margin:0 18px;

        .button{
            line-height:54px;
            color:#fff;
            font-size:18px;
            height:54px;
            background:rgba(0,227,128,1);
            border-radius:5px;
            box-shadow:0px 2px 10px 2px rgba(90,234,158,0.45);
            margin-bottom:18px;
            padding-left:20px;
            position:relative;

            &:before{
                content:'';
                display:block;
                height:3px;
                width:12px;
                background: #fff;
                position:absolute;
                border-radius:5px;
                top:50%;
                right:20px;
                transform:translateX(-20%) translateY(-50%);

            }
            &:after{
                content:'';
                display:block;
                height:0;
                width:0;
                border-style:solid;
                border-width:8px 0 8px 8px;
                border-color:transparent #fff;
                position:absolute;
                top:50%;
                right:20px;
                transform: translateX(2px) translateY(-50%);
            }
        }
    }
</style>
<template>
    <div class="wrapper" :style="{minHeight:minHeight+'px'}">
        <div class="button-group">
            <div class="button" v-for="item in list" @click="$router.go({name:'survey-detail',query:{sid:item.sid}})">
                {{item.title}}
            </div>
        </div>
        <BottomBar ></BottomBar>
    </div>
</template>
<script type="text/ecmascript-6">
    import Store from '../lib/store';
    import api from '../lib/api';
    import BottomBar from '../components/BottomBar';

    export default {
        data() {
            return {
                list:[]
            }
        },
        computed: {
            minHeight(){
                return Store.state.minHeight;
            }
        },
        methods: {
            async init(){
                this.list = await api.getSurveyList()
            }
        },
        components: {
            BottomBar,
        },
        mounted() {
            this.init();
        }
    }
</script>


// WEBPACK FOOTER //
// survey-list.vue?63d3631c